var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":_vm.appear,"name":`wind--ui-transition__${_vm.direction}-${_vm.size}-${_vm.type}-${_vm.motion}`,"mode":_vm.mode},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave,"after-leave":_vm.afterLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }